import { render, staticRenderFns } from "./ShowChannelIcons.vue?vue&type=template&id=745b9d52&scoped=true&"
import script from "./ShowChannelIcons.vue?vue&type=script&lang=js&"
export * from "./ShowChannelIcons.vue?vue&type=script&lang=js&"
import style0 from "./ShowChannelIcons.vue?vue&type=style&index=0&id=745b9d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745b9d52",
  null
  
)

export default component.exports